import { createFileRoute } from "@tanstack/react-router";
import DashboardStatistici from "@/pages/DashboardStatistici";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dashboard/statistici/")({
  head: () => routeHead("/dashboard/statistici/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><DashboardStatistici /></SubscribedRoute>
  );
}
